import React, { useState } from "react";
import DateField from "../../components/DateField";
import VStack from "../../ui_atoms/VStack";
import type { Meta, StoryObj } from "@storybook/react";

function DateFieldStoryComponent() {
    const [date, setDate] = useState<Date | null>();
    return (
        <VStack gap={0.5} style={{ padding: 10, alignSelf: "stretch" }}>
            <DateField
                style={{ alignSelf: "stretch" }}
                value={date}
                minimumDate={new Date()}
                onChange={setDate}
                label="Birthdate"
            />
            <DateField
                style={{ alignSelf: "stretch" }}
                value={date}
                onChange={setDate}
                label="Meeting time"
                timePicker
            />
            <DateField
                style={{ alignSelf: "stretch" }}
                value={date}
                onChange={setDate}
                label="Meeting time"
                timePicker="7:30"
            />
        </VStack>
    );
}

const meta = {
    title: "Fields/Date",
    component: DateFieldStoryComponent,
    argTypes: {},
} satisfies Meta<typeof DateFieldStoryComponent>;

export default meta;

type Story = StoryObj<typeof meta>;

export const Basic: Story = {
    args: {},
};
